export default {
  SET_SAVEDS: "SET_SAVEDS",
  GET_USERDATAS: "GET_USERDATAS",
  SET_FAVOURITES: "SET_FAVOURITES",
  SET_TOKEN: "SET_TOKEN",
  SET_USERNAME: "SET_USERNAME",
  CLEAR_USERDATAS: "CLEAR_USERDATAS",
  SET_FIRSTNAME: "SET_FIRSTNAME",
  SET_LASTNAME: "SET_LASTNAME",
  GET_PATTERNS_ALL: "GET_PATTERNS_ALL",
}
